import { render } from "./ConfigManualFile.vue?vue&type=template&id=4ea41192"
import script from "./ConfigManualFile.vue?vue&type=script&lang=ts"
export * from "./ConfigManualFile.vue?vue&type=script&lang=ts"

import "./ConfigManualFile.vue?vue&type=style&index=0&id=4ea41192&lang=scss"
import "./ConfigManualFile.vue?vue&type=style&index=1&id=4ea41192&lang=scss"
script.render = render

export default script